import * as React from "react";
const SvgFiRrSwimmer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-swimmer_svg__a)">
      <path
        fill="#062147"
        d="M2 2a1 1 0 0 1 1-1h4.916a5 5 0 0 1 4.1 2.136l5.114 7.317a1.001 1.001 0 0 1-1.641 1.147l-3.473-4.97-8.423 6.177a1 1 0 1 1-1.184-1.614l8.461-6.2-.495-.707A3 3 0 0 0 7.916 3H3a1 1 0 0 1-1-1m20.333 18.49A2 2 0 0 1 21 21a2.25 2.25 0 0 1-2.057-1.333 1 1 0 0 0-1.885 0 2.254 2.254 0 0 1-4.115 0 1 1 0 0 0-1.885 0 2.255 2.255 0 0 1-4.115 0 1 1 0 0 0-1.885 0A2.25 2.25 0 0 1 3 21a2 2 0 0 1-1.333-.511 1 1 0 0 0-1.335 1.489A4 4 0 0 0 3 23a4.38 4.38 0 0 0 3-1.225 4.286 4.286 0 0 0 6 0 4.286 4.286 0 0 0 6 0A4.38 4.38 0 0 0 21 23c.985 0 1.936-.364 2.668-1.023a1.001 1.001 0 0 0-.607-1.764 1 1 0 0 0-.728.277M3 18a4.38 4.38 0 0 0 3-1.225 4.286 4.286 0 0 0 6 0 4.286 4.286 0 0 0 6 0A4.38 4.38 0 0 0 21 18c.985 0 1.936-.364 2.668-1.023a1.001 1.001 0 0 0-.607-1.764 1 1 0 0 0-.729.277A2 2 0 0 1 21 16a2.25 2.25 0 0 1-2.057-1.333 1 1 0 0 0-1.885 0 2.254 2.254 0 0 1-4.115 0 1 1 0 0 0-1.885 0 2.255 2.255 0 0 1-4.115 0 1 1 0 0 0-1.885 0A2.25 2.25 0 0 1 3 16a2 2 0 0 1-1.333-.511 1 1 0 0 0-1.335 1.489A4 4 0 0 0 3 18M18.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-swimmer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSwimmer;
